import { mapState } from 'vuex'
import ConfettiGenerator from 'confetti-js'

import membershipLib from 'lib/membership'
import eventBus from 'lib/eventBus'

export default {
  name: 'membership-complete',
  computed: {
    ...mapState({
      loggedIn: (state) => state.auth.loggedIn,
      user: (state) => state.user.current,
    }),
    affiliate() {
      return this.$store.state.membership.currentAffiliate || {}
    },
    isUserMember() {
      return membershipLib.isUserMember(this.user)
    },
  },
  data() {
    return {}
  },
  methods: {
    onReferralCodeCopied($event) {
      $event.trigger.select()
    },
  },
  mounted() {
    const confettiSettings = {
      target: 'confetti-canvas',
      max: '100',
      animate: true,
      props: ['square', 'triangle', 'line'],
      colors: [
        [165, 104, 246],
        [230, 61, 135],
        [0, 199, 228],
        [253, 214, 126],
      ],
      clock: '10',
      rotate: false,
    }
    const confetti = new ConfettiGenerator(confettiSettings)

    confetti.render()

    if (!this.loggedIn) {
      this.$router.push({
        name: 'MembershipStart',
      })
    } else if (this.isUserMember) {
      // this.$router.push({
      //   name: 'MembershipPerks'
      // });
    } else {
      this.$router.push({
        name: 'MembershipSelectPlan',
      })
    }
  },
  updated() {
    eventBus.$emit('updated')
  },
}



// WEBPACK FOOTER //
// ./src/components/MembershipSuccess/script.js?vue&type=script&lang=js&